import React from 'react'
import styled from '@emotion/styled'
import CatalogFooterImg from '../../static/catalog-footer.png'
import CatalogFaFooterImg from '../../static/catalog-fa-footer.jpeg'

const Wrapper = styled.div`
  max-width: 1440px;
  padding: 0 3rem;
  margin: 0 auto;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    display: block;
    padding: 0 1rem;
  }
  > div {
    width: 50%;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 100%;
      p{
        text-align: center;
      }
    }
    p {
      font-family: 'Source Sans Pro', -apple-system, 'BlinkMacSystemFont', 
      'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif, 'Apple Color Emoji', 
      'Segoe UI Emoji', 'Segoe UI Symbol';
      margin: 2rem 0;
      a {
        color: #67471f;
        font-style: normal;
        font-weight: 600;
      }
      small {
        display: block;
      }
      span {
        display: block;
        margin-top: .5rem;
      }
    }
    &:last-of-type {
      p {
        text-align: right;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
          text-align: center;
        }
      }
    }
  }
`

const imgs = {
  'fonds-d-atelier': CatalogFaFooterImg,
  '2021-2022': CatalogFooterImg
};

const CatalogFooter = (props) => {
  
  return (
    <>
      <Wrapper>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}>
          <h2 style={{
            textTransform: 'uppercase',
            fontFamily: "'Roboto',sans-serif",
            fontSize: '30px',
            fontWeight: 200,
            marginBottom: 0,
          }}>Expositions</h2>

          <h4 style={{ padding: '1rem 0', textAlign: 'left', margin: 0 }}>EXPOSITIONS / Personnelles</h4>
          <p style={{ textAlign: 'left', margin: 0 }}>Mélancoria, Galerie Kurokami, Paris, septembre 2025.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Murmures, Galerie Bansard, Paris, septembre 2020.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Carré France de Moscou, Moscou, Russie, septembre 2015.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>L’Enfant Artistique, Paris, 2014.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Galerie Artshome, Tours, 2011.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Salon Art Shopping, Carrousel du Louvre, Paris, 2010.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Galerie Everarts, Paris, 2009.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Côté Maison, France 3, 2008.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Rencontre des toiles, Ménerbes, 2007. (collective).</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Atelier Nollet, Paris, 2006.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Dolce Frégate Hotel, Saint-Cyr-sur-Mer, 2004–2006.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Galerie Armonti, Paris, 2003.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Galerie Everarts, Paris, 2003.</p>
          <h4 style={{ padding: '1rem 0', textAlign: 'left', margin: 0 }}>EXPOSITIONS / Collectives</h4>
          <p style={{ textAlign: 'left', margin: 0 }}>Amitiés, Paris, septembre 2022,</p>
          <p style={{ textAlign: 'left', margin: 0 }}>27ème Salon des Artistes du 8ème, Paris, 2017,</p>
          <p style={{ textAlign: 'left', margin: 0 }}>26ème Salon des Artistes du 8ème, Paris, 2016,</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Art at the Hertford, Institut Hospitalier Franco Britannique, Levallois, 2015–2016.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>25ème Salon des Artistes du 8ème, Paris, 2015.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>24ème Salon des Artistes du 8ème, Paris, 2014.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>23ème Salon des Artistes du 8ème, Paris, 2013.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Salon d’Automne de Coubron, Galerie Art et Miss, Paris, 2013.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>22ème Salon des Artistes du 8ème, Paris, 2012.</p>
          <h4 style={{ padding: '1rem 0', textAlign: 'left', margin: 0 }}>Vente aux enchères / Drouot</h4>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Me Richard Bedeau, Hôtel Drouot, Paris, décembre 2025.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Secours Populaire, Vence, mai 2021.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2020–2021.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2019–2020.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2018–2019.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2017–2018.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris, 2016–2017.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2015–2016.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Hôtel Drouot, Paris / Lausanne, 2014–2015.</p>
          <p style={{ textAlign: 'left', margin: 0 }}>Vente aux enchères, Me Claude Aguttes, Neuilly, 2009.</p>
        </div>
      </Wrapper>
      
      <div style={{ 
        maxWidth: '1440px',
        padding: '0 3rem',
        margin: '3rem auto 0'
      }}><hr /></div>

      <Wrapper>
        <div>
          
          <h2 style={{
            textTransform: 'uppercase',
            fontFamily: "'Roboto',sans-serif",
            fontSize: '30px',
            fontWeight: 200,
            marginBottom: 0,
          }}>Contact</h2>
          <p>
            Vous pouvez payer en plusieurs fois.<br />
            Pour plus d'informations, n'hésitez pas à <a href="mailto: mailto:dischr@gmail.com" title="dischr@gmail.com">me contacter</a>.
          </p>
        </div>
        <div>
          <p>
            Contact : <strong style={{ color: '#67471f' }}>Rémy Disch</strong> <br />
            Email: <a href="mailto:dischr@gmail.com">dischr@gmail.com</a><br />
          </p>
          <p>
            Site officiel : <br /><a href="https://www.dischr.com/" target="_blank">https://www.dischr.com</a><br />
            Patreon : <br /><a href="https://www.patreon.com/remy_disch/" target="_blank">https://www.patreon.com/remy_disch/</a><br />
          </p>
          <p>
            Partenaires<br />
            <a href="https://www.artsper.com/es/artistes-contemporains/france/102408/remy-disch" target="_blank">ARTSPER</a><br />
            <a
              href="https://www.gazette-drouot.com/recherche/lot/disch-remy?type=past&modeDiapo=&query=DISCH+R%C3%A9my&actuDatefilter=&exactMatch=false&order=dateDesc"
              target="_blank"
            >
              LA GAZETTE DROUOT
            </a>
          </p>
          <p>
            Suivez moi sur : <br />
            <a href="https://www.instagram.com/dischremy/" target="_blank">Instagram</a> <br />
          </p>
          <div>
            <img src={imgs[props.data.uid]} />
            <p>
              Artiste côté chez <strong>DROUOT COTATION</strong>
              <span>
                LA MAISON DES ARTISTES <br />
                SIRET 52852265900010
              </span>
            </p>
          </div>
        </div>
      </Wrapper>
    </>
  )
}

export default CatalogFooter;
